import { useQuery } from '@tanstack/react-query';
import { fetchAgentPerformance } from '@/lib/axios/api/widgets.api';

export function useAgentPerformance(agentId: string | null | undefined, startDate: string | undefined, endDate: string | undefined, queueMicrosoftIds?: string[] | null) {
  const query = useQuery({
    queryKey: ['agentPerformance', agentId, startDate, endDate, queueMicrosoftIds] as const,
    queryFn: ({ signal }) => fetchAgentPerformance({ agentId, startTime: startDate, endTime: endDate, queueMicrosoftIds, signal }),
    enabled: !!agentId && !!startDate && !!endDate,
  });

  return {
    performanceData: query.data,
    isPerfLoading: query.isPending && query.fetchStatus !== 'idle',
    isPerfError: query.isError,
  };
}
